import { SelectOption } from '@kanda-libs/ks-component-ts';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

export const PROPS = {
  pageTitle: {
    text: 'Personal Information',
    className: YOUR_INFO_CLASS_NAMES.title,
  },
  name: {
    label: 'Name',
  },
  title: {
    label: ' ',
    placeholder: 'Select...',
  },
  titleMobile: {
    label: 'Title',
    placeholder: 'Select...',
  },
  firstName: {
    autoCapitalize: 'on',
    autoCorrect: 'off',
    autoComplete: 'given-name',
    label: 'First Name',
    placeholder: 'First name',
  },
  lastName: {
    autoCapitalize: 'on',
    autoCorrect: 'off',
    autoComplete: 'family-name',
    label: 'Last Name',
    placeholder: 'Last name',
  },
  gender: {
    label: 'Gender',
    placeholder: 'Select...',
    name: 'credit.customer_details.gender',
  },
  middleName: {
    autoCapitalize: 'on',
    autoCorrect: 'off',
    autoComplete: 'additional-name',
    label: '',
    placeholder: 'Middle name',
    className: '!mb-0',
  },
  maidenName: {
    autoCapitalize: 'on',
    autoCorrect: 'off',
    label: '',
    placeholder: 'Maiden name',
    className: '!mb-0',
  },
  birthday: {
    label: 'Date of birth',
    placeholder: 'DD / MM / YYYY',
  },
  maritalStatus: {
    label: 'Marital status',
    placeholder: 'Select...',
  },
  numberOfDependents: {
    label: 'No. of dependents',
    placeholder: 'e.g. 0',
    validation: {
      required: {
        value: true,
        message: 'Number of dependents is required',
      },
      min: {
        value: 0,
        message: 'Number of dependents must be a minimum of 0',
      },
      max: {
        value: 20,
        message: 'Number of dependents must be a maximum of 20',
      },
    },
  },
};

export const GENDER_VALIDATION = {
  required: { value: true, message: 'Gender is required.' },
};

export const GENDER_OPTIONS: SelectOption[] = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
];
